import { GridView } from "@mui/icons-material";
import React from "react";
import { useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";

const SolarContract = () => {
    const { user_id, lead_id } = useParams();

    const { solar_contracts } = useSelector((state) => state.contract);
    const AllContracts = solar_contracts?.data?.data || [];
    AllContracts.map((contract, index) => {
        console.log(contract);
    });

    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const name = path.replace("-", " ");

    const CallBackToSolarContract = () => {
        return (
            <div>
                <NavLink
                    exact
                    to="/dashboard/solar-contracts"
                    style={{ margin: "0px 5px" }}
                    className="route-not-active"
                >
                    All Solar Contracts
                </NavLink>
            </div>
        );
    };

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span> {name} </span>
                </div>
                {user_id && CallBackToSolarContract()}
                {lead_id && CallBackToSolarContract()}
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default SolarContract;
